'use strict';exports.__esModule = true;var capitalizeFirstLetter = function capitalizeFirstLetter(string) {return (
    string ? string[0].toUpperCase() + string.slice(1) : '');};exports.default =

capitalizeFirstLetter;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/capitalizeFirstLetter.js
// module id = 385
// module chunks = 0